module.exports = __webpack_public_path__ + "static/img/PFKRose.7dd641d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFKRose.jpg
// module id = 251
// module chunks = 1